import useMediaQuery from '@restart/hooks/useMediaQuery';
import React, { MouseEventHandler, useCallback, useMemo } from 'react';
import { TrackerUtil } from '../../../tracking/TrackerUtil';
import { minBreakpoints } from '../../../utils/media-queries';
import IphoneImage from './IphoneImage';
import { HeroBadge } from '../../badge/HeroBadge';
import { useBranding } from '../../../hooks/useBranding';

const LG_WIDTH = minBreakpoints.lg;
const SIZE_DEFAULT = { width: 349, height: 486 };
const SIZE_BELOW_MD = { width: 285, height: 386 };

export const IphoneMock = () => {
  const isMdOrBelow = useMediaQuery(`(max-width: ${LG_WIDTH - 1}px)`);
  const branding = useBranding();
  const size = useMemo(() => (isMdOrBelow ? SIZE_BELOW_MD : SIZE_DEFAULT), [isMdOrBelow]);

  const onClick = useCallback<MouseEventHandler<HTMLDivElement>>((e) => {
    // Tracking
    TrackerUtil.trackBtnClick(
      `td-home_button_${'hero-cta'.split('-')[0]}`,
      `button_${'hero-cta'.split('-')[0]}`
    );

    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.append('alt_home', 'true');
    window.location.href = `/onboarding?${urlParams.toString()}`;
  }, []);

  return (
    <div className="iphone-wrapper">
      <HeroBadge />
      <div
        className={`iphone-click-wrapper ${branding === 'hug' ? 'invisible' : ''}`}
        onClick={onClick}
      >
        <IphoneImage size={isMdOrBelow ? SIZE_BELOW_MD : SIZE_DEFAULT} />
      </div>
    </div>
  );
};
